import React from 'react';

import SplashScreen from './src/react-view/screens/splash/splash.js';
import Root from './src/react-view/screens/root/root.js';


class AppStore {
} 


class App extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.base_name = 'my-dashboard';
		this.exec_env = App.EXEC_ENV;
		this.current_version = '0.15.27.2021.11.02';

		console.log('App constructor called');

		App.theapp = this;

		this.App = App;

		this.dashboard_model = null;

		this.mvcmydashboard = null;

		this.state = {
			loading: true,
		};

	}
	
	async onLoaded() {
		var _globalscope = window;

		console.log('App.onLoaded called');

		try {
			// mvc module

			// @primusmoney/react_client_wallet
			var React_Client_Wallet = require('@primusmoney/react_client_wallet');

			var react_client_wallet = React_Client_Wallet.getObject();

			var react_client_wallet_init = await react_client_wallet.init();

			// mvc module (used by some ModuleObject for communicating with app)
			var mvcmodule = react_client_wallet.getMvcAPI();
			var clientglobal = react_client_wallet.getGlobalObject();

			if (this.exec_env == 'dev') {
				console.log('App.onLoaded execution environment is DEV');
				
				// put app in simplestore for debugging purposes
				var commonmodule = clientglobal.getModuleObject('common');

				clientglobal.putGlobalStoredObject('DEBUG_global', clientglobal);
				clientglobal.putGlobalStoredObject('DEBUG_app', this);
				clientglobal.putGlobalStoredObject('DEBUG_session_array', commonmodule.session_array);
			}


			// set app object in mvcmodule
			mvcmodule.setAppObject(this);

			// alternatively version > 0.30.11, we can listening to events
			//mvcmyquote.registerEventListener('on_refreshPage', this.uuid, this.refreshPage.bind(this));
			//mvcmyquote.registerEventListener('on_gotoHome', this.uuid, this.gotoHome.bind(this));
			//mvcmyquote.registerEventListener('on_gotoLoginPage', this.uuid, this.gotoLoginPage.bind(this));


			if (!AppStore.mvcmodule){
				// because App can be constructed multiple times
				AppStore.mvcmodule = mvcmodule;
			}

			// create mvc mydashboard

			// initialize mydashboard-model module
			const Model = require('./src/model/model.js');
			
			//const model = Model.getObject(); // does not work in webpack (TypeError: "exports" is read-only)
			const model = clientglobal.getModuleObject('mydashboard-model');

			await model.initAsync();

			this.dashboard_model = model;

			// retrieve mvcmydashboard
			const mvcmydashboard = await model.getMvcMyDashboard();

			this.mvcmydashboard = mvcmydashboard;

			if (!AppStore.mvcmydashboard){
				// because App can be constructed multiple times
				AppStore.mvcmydashboard = this.mvcmydashboard;
			}

			await mvcmydashboard.initAsync();

			// TEST: set session scheme
			
			// on primusfinance_citadel
 	 		let scheme_uuid = '62ef4792-4ba6-0c27-c992-572684e9f9f5';
			let scheme_name = 'primusfinance_citadel';

			// on primusfinance hosted
/* 	 		let scheme_uuid = '4bf223aa-f5d9-db3e-cf25-2954462756a9';
			let scheme_name = 'primusfinance_hosted'; */

			// on primusfinance local storage
/* 			let scheme_uuid = '5079c781-2e3b-80b3-9ba1-5beb954a3da9';
			let scheme_name = 'primusfinance_device'; */

			// on p2p florin
/* 			let scheme_uuid = 'b1a18ba9-1609-3f66-c1fd-42ae0073efac';
			let scheme_name = 'florin'; */

			// on dev5_citadel
/* 			let scheme_uuid = 'c70103e6-69a5-fe9a-01b5-b25912785726';
			let scheme_name = 'devmachine5'; */


			let sessionuuid = await mvcmydashboard.getCurrentSession();
			let current_scheme = await mvcmydashboard.getScheme(sessionuuid, scheme_uuid).catch(err => {});

			if (!current_scheme) {
				let scheme_config = await model.getSchemeConfigFromName(scheme_name);
				//let scheme_config = await model.getSchemeConfigFromUUID(scheme_uuid);

				if (scheme_config)
				current_scheme = await mvcmydashboard.createScheme(sessionuuid, scheme_config);
			}

			if (current_scheme)
			await mvcmydashboard.setSessionScheme(sessionuuid, current_scheme.uuid);

			// END TEST

			this.setState({loading: false});
			return true;
		}
		catch(e) {
			console.log('exception in App.onLoaded: ' + e);
		}

		this.setState({loading: false});
		return false;
	}

	getMvcMyDashboardObject() {
		if (this.mvcmydashboard)
			return this.mvcmydashboard;
		else{
			if (AppStore.mvcmydashboard)
				this.mvcmydashboard = AppStore.mvcmydashboard;;

			return AppStore.mvcmydashboard;
		} 
	}

	async gotoHome() {
		console.log('App.gotoHome called');
	}
	
	async gotoLoginPage() {
		console.log('App.gotoLoginPage called');
	}


	async refreshPage() {
		console.log('App.refreshPage called');
		
	}

	// state & refresh
	async _setState(json) {
		return new Promise((resolve, reject) => {
			this.setState(json, (err, res) => {
				if (err) reject(err); else resolve(res);
			});
		})
	}

	// utils
	t(str) {
		return this.mvcmydashboard.t(str);
	}

	guid() {
		if (this.mvcmydashboard)
			return this.mvcmydashboard.guid();
		
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
		}
		
		return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
			s4() + '-' + s4() + s4() + s4();
	}
	

	// render
	render() {
		if (this.state.loading) {
			return (
				<div className="App">
					<SplashScreen 
						{...this.props} 
						app = {this}
					/>
				</div>
			);
		}

		return (
			<div className="App">
				<Root
					app = {this}
				/>
			</div>
		);
	}
	
	// static methods

	static getAppObject() {
		return App.theapp;
	}

} 

export default App;
